import React from 'react';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import Footer from './Footer';
import SiteLayout from './common/SiteLayout';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();

  if (pathname.includes('/music/register/') || pathname.endsWith('/music-register/completion')) {
    return <>{children}</>;
  }
  return <SiteLayout header={<NavBar />} footer={<Footer />}>{children}</SiteLayout>;
};

export default Layout;
